export default __webpack_public_path__ + "static/media/NW0070.34I-34484_-18977_0.a39d1ba7.jpg";